import { useContent } from "contexts/contentContext/contentContext";
import Button from "components/Elements/Button/Button";
import HeroBunnerSection from "../HeroBunnerSection/HeroBunnerSection";

import styles from "../hero.module.scss";
import { Dispatch, SetStateAction, useState } from "react";

interface HeroAdvertisingI {
  handleScrollToForm: () => void;
  isHeroBunnerScrolledToTop: boolean;
  setIsHeroBunnerScrolledToTop: Dispatch<SetStateAction<boolean>>;
}

const HeroAdvertising = ({
  handleScrollToForm,
  isHeroBunnerScrolledToTop,
  setIsHeroBunnerScrolledToTop,
}: HeroAdvertisingI) => {
  const { getTextByKey, getDirection } = useContent();
  const RTLDirection = getDirection() === "rtl";
  const [isFormBtnClick, setIsFormBtnClick] = useState(false);

  return (
    <div className={styles.heroAdvertising}>
      <div className={styles.heroAdvertisingTextContent}>
        {!RTLDirection && (
          <p className={styles.heroAdvertisingOnJmailText}>
            {getTextByKey("hero-advertising-on-jmail-text")}
          </p>
        )}

        <div className={styles.heroAdvertisingTitleWrap}>
          <h1>{getTextByKey("hero-advertising-title")}</h1>
          <h2>{getTextByKey("hero-advertising-title-text")}</h2>
        </div>
        <p className={styles.heroAdvertisingDescription}>
          {getTextByKey("hero-advertising-description")}
        </p>
        <Button
          className="advertising-button"
          onClick={() => {
            setIsFormBtnClick(true);
            handleScrollToForm();
            setTimeout(() => {
              setIsFormBtnClick(false);
            }, 1000);
          }}
        >
          {getTextByKey("hero-advertising-button-text")}
        </Button>
      </div>
      <HeroBunnerSection
        handleScrollToForm={handleScrollToForm}
        isHeroBunnerScrolledToTop={isHeroBunnerScrolledToTop}
        setIsHeroBunnerScrolledToTop={setIsHeroBunnerScrolledToTop}
        isFormBtnClick={isFormBtnClick}
        setIsFormBtnClick={setIsFormBtnClick}
      />
    </div>
  );
};

export default HeroAdvertising;
